import instanceService from './instance'

import { CLIENT_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(CLIENT_SERVER_URL)

export const clientService = {
  getShortInfo,
  getClientDetails,
  createClient,
  updateClient,
  searchClients,
  composeProfiles,
  getFullNameDeal
}

function getFullNameDeal(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/list'
  }
  return instance(options)
}

function getShortInfo(id) {
  return instance.get(`${id}/short`)
}

function getClientDetails(id) {
  return instance.get(`${id}`)
}

function createClient(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/'
  }
  return instance(options)
}


function updateClient(id, data) {
  const options = {
    method: 'PATCH',
    data: data,
    url: `/${id}`
  }
  return instance(options)
}

function searchClients(data) {
  const options = {
    method: 'POST',
    url: '/list',
    data
  }
  return instance(options)
}

function composeProfiles(ids) {
  const options = {
    method: 'PUT',
    url: `/${ids}`
  }
  return instance(options)
}
